import AuthService from '../../AuthService';
const sponserProgram = {
  getSponserProgram(page){
    return AuthService.get(`/about/sponser_program?page=${page}`);
  },
  showSponserProgram(id){
    return AuthService.get(`/about/sponser_program/${id}`);
  },
  createSponserProgram(data){
    return AuthService.post(`/about/sponser_program`,data);
  },
  updateSponserProgram(id,data){
    return AuthService.put(`/about/sponser_program/${id}`,data);
  },
  deleteSponserProgram(id){
    return AuthService.delete(`/about/sponser_program/${id}`);
  },
}
export default sponserProgram
